module.exports = __webpack_public_path__ + "media/images/iconSocialLink__errorRed-eef85c77f9a2e4e6cf9ca24e3c12c54c.png";